module.exports = __webpack_public_path__ + "static/media/sarvvidLogo.5b53b9a7.svg";